import React from 'react'
import { useSupplier } from '@klear/ui/hooks/use-suppliers'
import { EntityWizardShell } from '@klear/ui/wizard/entity-shell'
import { SupplierFlow, type SupplierFlowMode } from '@klear/supplier-ui/supplier-step-group'

interface SupplierWizardProps {
  mode: SupplierFlowMode
  supplierId?: number
  traderId?: number
  title?: string
  showTraderSelect?: boolean
  showIdentifiers?: boolean
  showParentOrganization?: boolean
  showCompanyLookup?: boolean
  canEdit?: boolean
  viewActions?: React.ReactNode
  viewExtras?: React.ReactNode
  onBack: () => void
  onDone: () => void
  onEdit?: () => void
}

export function SupplierWizard({
  mode,
  supplierId,
  traderId,
  title,
  showTraderSelect = false,
  showIdentifiers = false,
  showParentOrganization = false,
  showCompanyLookup = true,
  canEdit = false,
  viewActions,
  viewExtras,
  onBack,
  onDone,
  onEdit
}: SupplierWizardProps) {
  const { supplier, error, isLoading: isLoadingSupplier } = useSupplier(supplierId ?? 0, traderId)

  return (
    <EntityWizardShell
      mode={mode}
      entityLabel="Supplier"
      entityName={supplier?.name}
      title={title}
      canEdit={canEdit}
      viewActions={viewActions}
      isLoading={isLoadingSupplier}
      error={error}
      notFound={mode !== 'create' && !supplier}
      notFoundLabel="Supplier not found"
      onBack={onBack}
      onEdit={onEdit}
    >
      {({ activeMode, onNavStateChange, cancelEdit, requestExit, onDirtyChange }) => (
        <SupplierFlow
          key={`${activeMode}:${supplierId ?? 'new'}:${traderId ?? ''}`}
          mode={activeMode}
          supplier={supplier ?? undefined}
          supplierId={supplierId}
          traderId={traderId}
          showTraderSelect={showTraderSelect}
          showIdentifiers={showIdentifiers}
          showParentOrganization={showParentOrganization}
          showCompanyLookup={showCompanyLookup}
          viewExtras={viewExtras}
          onNavStateChange={onNavStateChange}
          onDirtyChange={onDirtyChange}
          onComplete={() => onDone()}
          onCancel={activeMode === 'create' ? requestExit : cancelEdit}
        />
      )}
    </EntityWizardShell>
  )
}
